<template>
  <div>
    <v-textarea
      :value="value"
      :disabled="disabled"
      :error-messages="validationError"
      :label="label"
      @change="$emit('change', $event)"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: "TextArea",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validationError: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped></style>
